import { useMutation } from '@apollo/client';
import type { ApiOptions } from '../helpers';
import { LoginDocument } from './login.generated';

export const useLoginUser = (options: ApiOptions<typeof LoginDocument> = {}) =>
  useMutation(LoginDocument, {
    ...options,
  });
